const COE_SSO_SESSION_PATH = '/coe/sso-session'
const LOYALIZE_API = 'https://api.loyalize.com/resources/stores/'
const NFT_BALANCES_SHOULD_FETCH_NFT_URL_PARAM = '?should_fetch_nft_url=true'

const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PATCH: 'PATCH',
  DELETE: 'DELETE'
}

const API_RESPONSE = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  CONFLICT: 409
}

const API_PATH = {
  UGC: '/ugc',
  UGC_STATS: '/ugc-stats',
  REFERRAL_STATS: '/referral-stats'
}

export {
  API_PATH,
  API_RESPONSE,
  COE_SSO_SESSION_PATH,
  HTTP_METHOD,
  LOYALIZE_API,
  NFT_BALANCES_SHOULD_FETCH_NFT_URL_PARAM
}
